import { UseAccountantCommissionList } from '../../hooks/useAccountantCommissionList';
import GeneralCommissionProgressList from '../common/commission/generalCommissionProgressList';
import EditSalesCommissionModal from './editSalesCommissionModal';

export default function AccountantCommissionListWrapper({
    apiCall,
    onSave,
    visibleColumns,
}) {
    const {
        commissionList,
        showEditCommissionModal,
        selectedCommission,
        handleViewCommissionModal,
        handleCloseEditCommissionModal,
        refetchData
    } = UseAccountantCommissionList(apiCall);

    const handleSave = () => {
        if (onSave) {
            onSave();
        } else {
            refetchData();
        }
    };

    return (
        <>
            <GeneralCommissionProgressList
                fetchData={commissionList}
                onRowClick={handleViewCommissionModal}
                visibleColumns={visibleColumns}
            />

            <EditSalesCommissionModal
                show={showEditCommissionModal}
                onHide={handleCloseEditCommissionModal}
                selectedCommission={selectedCommission}
                onSaved={handleSave}
            />
        </>
    );
}
